import { ContentfulImage } from 'components/Image'
import { Stack } from 'components/Stack'
import { Caption, Text, Title, Title_h4_default } from 'components/Typography'
import { Trans, useTranslation } from 'next-i18next'
import { colors } from 'utils/colors'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { EstatePlanningPriceType } from 'utils/getInitialEstatePlanningPrice'
import { useEstatePlanPrice } from 'utils/promo'

export function StartSection({
  estatePlanningPrice,
}: {
  estatePlanningPrice: EstatePlanningPriceType
}) {
  const { t } = useTranslation('pricing_plan')
  const { t: tCommon } = useTranslation('common')
  const images = useContentfulImages()

  const estatePlanningPriceForUser = useEstatePlanPrice(estatePlanningPrice)
  const { type: discountType } = estatePlanningPriceForUser

  return (
    <section>
      <Stack space={['1rem', '1.5rem']}>
        <Title variant={Title_h4_default} css={{ textAlign: 'center' }} color={colors.black}>
          {t('pricing_plan.pricing_flow.title')}
        </Title>
        <div css={{ margin: '0 1rem' }}>
          <div css={{ maxWidth: '600px', margin: 'auto' }}>
            <ContentfulImage {...images.trust_pricing_hero} />
          </div>
        </div>
        <Stack space="0.5rem" css={{ alignItems: 'center', margin: '0 1rem' }}>
          {discountType !== 'recurring' && (
            <Title color={colors.gray[100]} variant="h6">
              {discountType === 'initial-no-discount' ? (
                estatePlanningPriceForUser.undiscountedPriceText
              ) : discountType === 'initial-discount' ||
                discountType === 'initial-free-subscription' ? (
                <Trans
                  t={t}
                  i18nKey="pricing_plan.pricing_flow.discounted_price"
                  values={{
                    initialPrice: estatePlanningPriceForUser.undiscountedPriceText,
                    discountedPrice:
                      discountType === 'initial-free-subscription'
                        ? tCommon('common.free')
                        : estatePlanningPriceForUser.discountedText,
                  }}
                  components={[
                    <Text
                      key={0}
                      variant="subtitleBold"
                      css={{ textDecoration: 'line-through' }}
                      color={colors.black}
                    />,
                    <Text key={1} variant="subtitleBold" color={colors.black} />,
                  ]}
                />
              ) : null}
            </Title>
          )}
          <Caption css={{ textAlign: 'center' }}>
            {t('pricing_plan.pricing_flow.caption', {
              context: discountType === 'recurring' ? 'recurring' : undefined,
            })}
          </Caption>
        </Stack>
      </Stack>
    </section>
  )
}
